export const RESET_CALL_SETTINGS = 'RESET_CALL_SETTINGS';
export const TOGGLE_REMEMBER_SETTINGS = 'TOGGLE_REMEMBER_SETTINGS';
export const TOGGLE_AUDIO_TEST = 'TOGGLE_AUDIO_TEST';
export const PSTN_ID = 'PSTN';
export const AV_SETTINGS = 'AV_SETTINGS';
